import { Button, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import dayjs from 'dayjs';
import InputNumber from 'components/input-number';
import DatePickerMobile from 'components/date-picker/mobile';

const { Option } = Select;

const VoucherModalMobile = ({ viewModel }) => {
  const {
    form,
    isModalOpen,
    voucher,
    handleOk,
    handleCancel,
    onFinish,
    copyVoucherCode,
  } = viewModel;

  return (
    <Modal
      title='Thêm voucher'
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText='Lưu'
      cancelText='Huỷ'
      width='100%'
      style={{ top: 16 }}
    >
      <Form
        name='basic'
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete='off'
        form={form}
        layout='vertical'
      >
        <Form.Item name='id' hidden />

        <Form.Item label='Mã' name='code'>
          <Input
            disabled={voucher.id}
            addonAfter={voucher.id ? <Button size='small' onClick={() => copyVoucherCode(voucher.code)}>Copy</Button> : null}
          />
        </Form.Item>

        <Form.Item label='Mô Tả' name='description' rules={[{ message: 'Please input voucher description!' }]}>
          <Input />
        </Form.Item>

        <Form.Item name='type' label='Loại Voucher' rules={[{ required: true }]}>
          <Select>
            <Option value='fixed'>Giảm số tiền cố định</Option>
            <Option value='percentage'>Giảm theo %</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label='Giá trị'
          name='value'
          rules={[
            { required: true, message: 'Vui lòng nhập giá trị voucher' },
            ({ getFieldValue }) => ({
              validator(_, inputValue) {
                const value = Number(inputValue);
                if (!Number.isFinite(value) || value <= 0) {
                  return Promise.reject(new Error('Giá trị voucher phải lớn hơn 0'));
                }
                const type = getFieldValue('type');
                if (type === 'percentage' && value > 100) {
                  return Promise.reject(new Error('Tỉ lệ giảm phải từ 0 đến 100%'));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label='Số lần dùng' name='usage_limit' rules={[{ required: true, message: 'Please input voucher usage_limit!' }]}>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label='Số lần dùng mỗi khách' name='usage_limit_per_customer' rules={[{ required: true, message: 'Please input usage limit per customer!' }]}>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label='Giá trị đơn tối thiểu' name='min_order_amount'>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item label='Giảm tối đa (cho voucher %) ' name='max_discount_amount'>
          <InputNumber style={{ width: '100%' }} />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name='is_active' valuePropName='checked'>
              <Checkbox>Đang hoạt động</Checkbox>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='is_public' valuePropName='checked'>
              <Checkbox>Công khai cho khách</Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item name={['limit', 'time', 'is_limit']} valuePropName='checked' noStyle>
          <Checkbox>Giới hạn thời gian</Checkbox>
        </Form.Item>

        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label='Ngày bắt đầu'
              name={['limit', 'time', 'start']}
              getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
            >
              <DatePickerMobile style={{ width: '100%' }} format='DD/MM/YYYY' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='Ngày kết thúc'
              name={['limit', 'time', 'end']}
              getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
            >
              <DatePickerMobile style={{ width: '100%' }} format='DD/MM/YYYY' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default VoucherModalMobile;